<template>
<v-container fluid>
  <div class="title ms-5 my-5">Administration Page</div>
  <v-btn-toggle
    v-model="selected_component"
    mandatory
    tile
    color="deep-purple accent-1"
    group
    class=""
  >
    <v-btn
      v-for="(comp, c_idx) in the_components"
      :key="c_idx"
      :value="comp.value"
      class="mx-2"
    >{{ comp.name }}</v-btn>
  </v-btn-toggle>
  <!-- <KeepAlive> -->
    <component :is="selected_component" @snackbar_show="create_snackbar" />
  <!-- </KeepAlive> -->
  <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="2000"
    >{{ snackbar.text }}
    </v-snackbar>
</v-container>
</template>

<script>
/* eslint-disable */
import Domains from "@/components/admin/Domains.vue"
import Clients from "@/components/admin/Clients.vue"
import ClientsSellers from "@/components/admin/ClientsSellers.vue"
import NewProduct from '@/components/production/N_NewProduct.vue'
import Users from '@/components/admin/Users.vue'
import Variations from '@/components/admin/Variations.vue'
// import Permissions from '@/components/admin/Permissions.vue'

export default {
  name: 'Admin-View',
  components: {
    Domains,
    Clients,
    ClientsSellers,
    NewProduct,
    Users,
    Variations
  },
  data: () => ({
    selected_component: undefined,
    snackbar: {
      show: false,
      color: 'purple',
      text: "",
    },
    the_components: [
      {
        name: 'Domains',
        value: 'Domains',
      },
      {
        name: 'Clients',
        value: 'Clients',
      },
      {
        name: 'Clients Sellers',
        value: 'ClientsSellers',
      },
      {
        name: 'New Product',
        value: 'NewProduct',
      },
      {
        name: 'Users',
        value: 'Users',
      },
      {
        name: 'Variations',
        value: 'Variations',
      },
    ],
  }),
  computed: {
    clients_length() {
      return this.$store.state.productionModule.clients_list.length;
    },
  },
  methods: {
    create_snackbar({text, color}){
      this.snackbar.text = text;
      if(!!color) this.snackbar.color = color;
      this.snackbar.show = true;
    }
  },
  created() {
    if (this.clients_length < 2) {
      const payload = { task: "load_clients" };
      this.$store
        .dispatch("productionModule/general_api", payload)
        .then((res) => {
          console.log('clients', JSON.parse(JSON.stringify(res.data.clients)))
          const active_clients = res.data.clients.filter(a => a.active);
          const actives = { value: active_clients, key: 'clients_list'}
          this.$store.commit("productionModule/SET_PRODUCTION_STATE", actives);
          const inactive_clients = res.data.clients.filter(a => !a.active);
          const inactives = { value: inactive_clients, key: 'inactive_clients'}
          this.$store.commit("productionModule/SET_PRODUCTION_STATE", inactives);
        });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Admin.vue